import { docReady } from '../helpers/docReady';
import '../../styles/templates/collection.scss';
import { mainCollection } from '../sections/mainCollection';
docReady(() => {
    mainCollection();
    // console.log('Cardigang: Collection JS Loaded');
});
